export function padZero(str, len = 2) {
  return (new Array(len).join('0') + str).slice(-len);
}